module.exports = "<ng-template #operationDetails></ng-template>\n"